import { useState } from "react"
import { AbsoluteContainer, AppSpan, CustomContainer, FlexRow } from "src/style"
import { BorrowingActivities, Conversations, CustomerData, LendingActivities, LoginHistory, Transactions } from "src/component"

export const CustomerInfoView: React.FC<any> = ({data}) => {
    const [navPosition, setNavPosition] = useState(0)

    return (
        <CustomContainer topMargin="3.7" bottomPadding="3">
            <CustomContainer className="customer-info-view-nav-wrap">
                <CustomContainer className="customer-info-view-nav" overflow="auto" >
                    <AbsoluteContainer bottom="0" left={`${navPosition}`}>
                        <CustomContainer bgColor="#4C6FFF" width="11.5" height="0.3" />
                    </AbsoluteContainer>
                    <FlexRow gap="3.5">
                        <AppSpan 
                            color={navPosition === 0 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(0)}
                        >
                            Customer Info
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 13.8 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(13.8)}
                        >
                            Lending activities
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 30 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(30)}
                        >
                            Borrowing activities
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 45 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(45)}
                        >
                            Transactions
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 58 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(58)}
                        >
                            Conversations
                        </AppSpan>
                        <AppSpan 
                            color={navPosition === 71 ? "#1A202C" : "#A0AEC0"}
                            textSize="1.2" leftPadding="1" rightPadding="1" cursor="pointer"
                            onClick={() => setNavPosition(71)}
                        >
                            Login History
                        </AppSpan>
                    </FlexRow>
                </CustomContainer>
            </CustomContainer>
            { navPosition === 0 ?
                <CustomerData data={data} /> :
                    navPosition === 13.8 ? 
                        <LendingActivities /> :
                            navPosition === 30 ?
                                <BorrowingActivities /> :
                                    navPosition === 45 ?
                                        <Transactions /> :
                                            navPosition === 58 ?
                                                <Conversations /> :
                                                    navPosition === 71 ?
                                                        <LoginHistory />
                                                            : null
            }
        </CustomContainer>
    )
}